import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    desempeño: [],
  },

  getters: {
    getDesempeño: (state) => state.desempeño,
  },

  mutations: {
    SET_DESEMPEÑO(state, desempeño) {
      state.desempeño = desempeño;
    },
  },

  actions: {
    async fetchDesempeño({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catdesempenio')
        .then((response) => {
          commit('SET_DESEMPEÑO', response.data.data);
        });
    },
  },
};
